import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AppGlobals } from '../globals/appGlobals';
import { IPermission, IServiceError, IUserAccessPermissions, IUserLoginData } from '../models/index';
import { AuthenticationService } from './authentication.service';
import { StorageManagerService } from './storage-manager.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';


@Injectable({ providedIn: 'root' })
export class AuthorizationService {

  private accessSettings: IUserAccessPermissions;
  public hasPermissionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public lastLogonDateSourceSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor (private router: Router, private storage: StorageManagerService,
    private authenticationService: AuthenticationService, private storageManagerService: StorageManagerService, private appGlobals: AppGlobals, private oidcSecurityService: OidcSecurityService) { }

  // Checks whether the user has permission to the application or not
  public getPermisions(displayableId: string): any {

    const permissions$ = this.authenticationService.get(`${ window.location.origin }/api/user/permissions?loginName=${ displayableId }&appName=SingleSource`);

    return permissions$;
  }

  public setAccessPermissions(email: string): any {

    let customer: any;
    let url: string;
    let dataScope: string;
    let userData: IUserLoginData;
    let applicationName: string;


    if (email) {

      customer = this.storageManagerService.read('currentCustomer');
      // don't need a datascope because the call returns all permission per client and they are filtered in the calling component
      dataScope = ''; // this.storageManagerService.read('dataScope') ? this.storageManagerService.read('dataScope') : '';
      userData = this.storageManagerService.read('userData');

      if (userData) {

        this.storageManagerService.read('dataScope');

        if (customer && typeof customer !== 'object') {

          customer = JSON.parse(customer);
        }

        if (userData.applications && typeof userData.applications !== 'object') {

          applicationName = JSON.parse(userData.applications)[0].AName;
        }

         url = `${ window.location.origin }/api/User/AccessPermissions?loginName=${ email }&applicationName=${applicationName}&channel=${dataScope}&customerGuid=${ customer.customerGuid }`;

       // url = '../assets/mock/accessObject.json'; // mock permission data

        return this.authenticationService.get(url);
      }
    }
  }

  hasPermissionPerClient(permissionName: string): boolean {

    let retVal = false;

    const permissions: IPermission[] = this.storageManagerService.read('accessPermissions');

    if (!permissionName || !permissions || !permissions.length) {
      return retVal;
    }

    retVal = permissions.findIndex(i => i.permissionName === permissionName) >= 0;

    return retVal;
  }

  hasPermission(permissionName: string): boolean {

    let retVal = false;

    // returns an array of IPermision
    const permissions: IPermission[] = this.storageManagerService.read('accessPermissions');
    const dataScope = this.storageManagerService.read('dataScope');

    if (!permissionName || !permissions || !permissions.length) {
      return retVal;
    }

    if (dataScope) {
      retVal = permissions.findIndex(p => p.applicationVariantName.toLowerCase() === dataScope.toLowerCase() && p.permissionName === permissionName) > 0;
    } else {
      retVal = permissions.findIndex(p => p.permissionName === permissionName) > 0;
    }

    return retVal;
  }

  exportDataPermission() {

    let retVal = false;

    const exportDataPermissions = [
      this.appGlobals.permissions.CreateEditExportTemplate,
      this.appGlobals.permissions.ExecuteExportDownloadTemplate,
      this.appGlobals.permissions.DeleteExportTemplate
    ];

    const permissions: IPermission[] = this.storageManagerService.read('accessPermissions');

    if ( !permissions || !permissions.length) {
      return retVal;
    }

    retVal = permissions.some( p => exportDataPermissions.includes(p.permissionName) );

    return retVal;
  }

  permissionsToStringObject(permissionSet): string[] {

    let retVal: string[] = [];

    // create a set of unique permission strings.
    if (permissionSet && permissionSet.length) {

      retVal = permissionSet.map((item: IPermission) => item.permissionName)
        .filter((value, index, self) => self.indexOf(value) === index);
    }

    return retVal;
  }

  
  loginEntraId() {
    this.oidcSecurityService.authorize("entraId", { customParams: { prompt: 'login' }});
  }

  private handleHttpError(error: HttpErrorResponse): Observable<IServiceError> {

    let errorMessage = '';

    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${ error.error.message }`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${ error.status }\nMessage: ${ error.message }`;
    }

    const dataError = new IServiceError();
    dataError.errorNumber = error.error ? error.error.number : 0;
    dataError.message = errorMessage ? errorMessage : '';
    dataError.friendlyMessage = `Oops.. Something's wrong.. Please try again later.`;
    dataError.errorMessage = errorMessage ? errorMessage : '';
    dataError.errorStatus = error.status;
    dataError.url = error.url;

    // return an observable of an IServiceError object with a user friendly error message
    return throwError(dataError);
  }
}
